import React, { Component } from 'react'
import { FILTRO_TEXTO_LIVRE } from '../../util/filtros'

class CampoBusca extends Component {
  constructor (props) {
    super(props);
    this.state = { textoBusca: '' };
    this.submeterBusca = this.submeterBusca.bind(this);
    this.handleKeyUp = this.handleKeyUp.bind(this)
  }

  adicionarParametroNoFiltro (chave, label, valor) {
    if (valor) {
      this.props.adicionarFiltro({ chave, label, valor })
    }
  }

  submeterBusca () {
    const filtro = this.props.filtrosAdicionados.filter(f => f.chave === FILTRO_TEXTO_LIVRE.chave);
    if (filtro.length === 1) {
      this.props.removerFiltro(filtro[0])
    }
    this.adicionarParametroNoFiltro(FILTRO_TEXTO_LIVRE.chave, FILTRO_TEXTO_LIVRE.label, this.state.textoBusca)
  }

  handleKeyUp = e => (e.key === 'Enter' ? this.submeterBusca() : this.setState({ textoBusca: e.target.value }));

  render () {
    return (
      <React.Fragment>
        <span className="input-group-prepend">
          <button id="btn-campo-busca-acordao" type="submit" className="input-group-text bg-white btn-campo-busca"
                  onClick={this.submeterBusca}>
            <i className="material-icons">&#xe8b6;</i>
          </button>
        </span>
        <input id="campo-busca-acordao" className="form-control form-control-lg campo-busca" type="text"
               placeholder="Buscar" onKeyUp={this.handleKeyUp}/>
      </React.Fragment>
    )
  }
}

export default CampoBusca
